import { Spinner } from 'components/common'
import ApprovalManagerConfigForm from 'components/configuration/approvalManagerConfigForm'
import ConfigBackLink from 'components/configuration/configBackLink'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { ConfigurationWithId } from 'types/configuration'
import { fetchConfigurations } from 'utils/api/configApi'

const ApproverManagersConfigurations = () => {
  const [configuration, setConfiguration] = useState<ConfigurationWithId>()

  const [loading, setLoading] = useState<boolean>(true)
  const getConfig = async () => {
    try {
      const { data } = await fetchConfigurations({
        fields: ['approvalManagers'],
      })
      setConfiguration(data)
    } catch (error) {
      /* empty */
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getConfig()
  }, [])

  if (loading) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Spinner size="large" />
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Approver Configurations</title>
      </Helmet>

      <div className="mx-auto max-w-6xl">
        <ConfigBackLink />

        <h1 className="title text-3xl">Approver Configuration</h1>

        <ApprovalManagerConfigForm
          approvalManagers={configuration?.approvalManagers}
        />
      </div>
    </>
  )
}

export default ApproverManagersConfigurations
